export default {
  emailTemplate: "EmailTemplates",
  addEmailTemplate: "AddEmailTemplate",
  editEmailTemplate: "EditEmailTemplate",
};
